<template>
  <div id="app" ref="allapp">
    <router-view />
  </div>
</template>

<script>
export default {
  name: 'App',
}
</script>

<style>

.diseaseul .van-picker__confirm{
  font-size: 18px;
}
.diseaseul .van-picker__cancel{
  font-size: 18px;
}
.diseaseul .van-picker__title{
  font-size: 18px;
}
#oftime .wh_content,#Signin .wh_content{
  justify-content: space-between;
}
#oftime .wh_top_tag,#Signin .wh_top_tag{
  height: 33px;
}
#oftime .wh_content_item,#Signin .wh_content_item{
  height: 36px;
}
#oftime .wh_content_item .wh_isToday{
  border:1px solid rgba(255,161,39,1);
  background: none;
  /* color: #838490; */
  /* background:rgba(255,161,39,0.88); */
  /* color: #fff; */
}
#Signin .wh_content_item .wh_chose_day{
  background: none;
}
#Signin .wh_content_item .wh_isToday{
  background: none;
}
#Signin .wh_content .wh_content_item .mark1{
  border: 0;
  background: none;
  position: relative;
}
#Signin .wh_content .wh_content_item .mark1::after{
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  width: 33px;
  height: 30px;
  background: url(assets/images/activity/tag.png);
  background-size: 100% 100%;
}
#Signin .wh_content .wh_content_item .mark2{
  border: 0;
  background: #ECECEC;
  position: relative;
  color: #B8B8B8;
  border-radius: 50%;
}
/* #Signin .wh_content .wh_content_item .wh_other_dayhide{
  color: #bfbfbf;
  background: none;
} */


#oftime .wh_content_item .wh_isMark{
  /* border:1px solid rgba(255,161,39,1); */
  background: none;
  color: #bfbfbf;
}


#oftime .wh_content_item .wh_chose_day{
  background:rgba(255,161,39,0.88);
  color: #fff;
}
#Signin .wh_content_item .wh_chose_day{
  background: none;
}

#oftime  .wh_content_item, #oftime  .wh_content_item_tag,#Signin .wh_content_item,#Signin  .wh_content_item_tag{
  color:#838490;
}
#Signin .wh_top_changge{
  padding: 0.6rem 0;
  position: relative;
}
#Signin .wh_top_changge::after{
  position: absolute;
  content: '';
  width: 90%;
  bottom: 0;
  left: 0;
  right: 0;
  margin: auto;
  border-bottom:1px solid #E9E9E9 ;
}
#oftime .wh_top_changge li,#Signin .wh_top_changge li{
  color: #313447;
  height: 35px;
  font-size: 17px;
}
#oftime .wh_item_date,#Signin .wh_item_date{
  width: 33px;
  height: 33px;
}
#oftime .wh_jiantou2,#oftime .wh_jiantou1,#Signin .wh_jiantou2,#Signin .wh_jiantou1{
  border-color: #313447;
}
#oftime .wh_content_all{
  background: #FFF;
  border-radius: 1rem;
  box-shadow:0rem 0rem 1rem rgba(0,0,0,0.16);
}
#Signin .wh_content_all{
  background: #FFF;
  border-radius: 1rem;
}
  /* @import './assets/font/font.css'; */
  #app {
    font-family:PingFang SC,Heiti SC,Arial,SimHei;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    color: #4B4239;
    overflow-x: hidden;
  }
  *{
    margin: 0;
    padding: 0;
    box-sizing: border-box;
  }
  ul, li{
    list-style: none;
  }
  a{
    text-decoration: none;
  }
  button{
    display: inline-block;
    border: none;
    outline: none;
    background:rgba(255,161,39,1);
    text-align: center;
  }
  img{
    width: 100%;
  }
  /* 修改组件样式 */
  .van-picker__cancel{
    color: #666 !important;
  }
  .van-picker__confirm,
  .van-dialog__confirm, .van-dialog__confirm:active{
    color: rgba(255,161,39,1) !important;
  }
  #plan-detail .base .card .van-tabs--line .van-tabs__wrap,#all-policy .family-members .card .van-tabs--line .van-tabs__wrap{
    height: auto;
  }
  #plan-detail .base .card .van-tabs__nav--line,#all-policy .family-members .card .van-tabs__nav--line{
    padding-bottom: 0;
  }
  #plan-detail .base .card .van-tabs__line,#all-policy .family-members .card .van-tabs__line{
    display: none;
  }
  #plan-detail .base .card .van-tabs__nav,#all-policy .family-members .card .van-tabs__nav{
    justify-content: flex-start;
  }
  #plan-detail .base .card .van-tab,#all-policy .family-members .card .van-tab{
    background: #FFCC9A;
    box-shadow:0rem 0.125rem 0.375rem 0rem rgba(245,130,18,0.2);
    border-radius: 0.875rem;
    margin: 1.25rem 0.4375rem;
    height: 1.75rem;
    line-height: 1.75rem;
    color: #fff;
    font-size: 0.75rem;
    -webkit-box-flex: none;
    -webkit-flex: none;
    flex: none;
    padding: 0 1.375rem;
  }
  #plan-detail .base .card .van-tab--active,#all-policy .family-members .card .van-tab--active{
    background:rgba(255,161,39,1);
  }
  #plan-detail .detail-wrapper .van-swipe__indicator,#all-policy .detail-wrapper .van-swipe__indicator{
    background-color: #D2D2D2;
    opacity: 1;
  }
</style>
